export const lightTheme = {
  name: 'light',
  mainBG: "#EFEFEF",
  secondaryBG: 'white',
  headerBG: 'rgba(255, 255, 255, 0.9)',
  mainText: '#333333',
  secondaryText: '#555454',
  inverseText: 'white',
  hover: '#F1F1F1',
  footer: '#333333',
  timeline: '#cccccc',
  divider: '#cccccc',
}

export const darkTheme = {
  name: 'dark',
  mainBG: "#333333",
  secondaryBG: '#191D21',
  headerBG: '#191D21',
  mainText: '#cccccc',
  secondaryText: '#757982',
  inverseText: '#191D21',
  hover: '#333333',
  footer: '#191D21',
  timeline: '#191D21',
  divider: '#3F3F3F',
}